import * as React from "react";
import defaultStyle from "./AudioSliderBlockView.module.scss";
import { BlockBase, useBlocks, useUi } from "@jelly/lesson";
import classnames from "classnames";
import Slider from "@src/lms/jelly/extensions/components/slider/Slider";

export interface AudioSliderBlock extends BlockBase {
  type: "audioSlider";
  samples: Array<{ title: string; src: string }>;
  buttonLabel: string;
  axisLabel?: string;
  buttonAlignTo?: "left" | "right";
}

export const AudioSliderBlockView: React.FC<AudioSliderBlock> = (props) => {
  //slider indexes start from 1, as when you set them to start from 0 they mess up marks, so
  //here we add one empty slot to fix that

  const [sliderIndex, setSliderIndex] = React.useState<number>(1);
  const [autoplay, setAutoplay] = React.useState(false);
  const [fileUrl, setFileUrl] = React.useState<string>(props.samples[0].src);

  const marks = props.samples.map((sample) => sample.title);

  const block = useBlocks();
  const { Button, Pill } = useUi();

  const handelIndexSwitch = (index: number): void => {
    setSliderIndex(index);
    setFileUrl(props.samples[index - 1].src);
    setAutoplay(true);
  };

  const toggleAutoplay = (): void => {
    setAutoplay(!autoplay);
  };

  return (
    <div className={classnames(defaultStyle.root)}>
      <div className={classnames(defaultStyle.sliderRow)}>
        {props.axisLabel && <Pill>{props.axisLabel}</Pill>}
        <Slider
          theme="primary"
          value={sliderIndex}
          min={1}
          max={marks.length}
          onChange={(val) => handelIndexSwitch(val)}
          marks={marks}
        />
      </div>
      <div
        className={classnames(defaultStyle.buttonRow, [
          props.buttonAlignTo == "right" ? defaultStyle.alignRight : "",
          props.buttonAlignTo == "left" ? defaultStyle.alignLeft : "",
        ])}
      >
        <Button
          onClick={() => {
            toggleAutoplay();
          }}
          icon={autoplay ? "cis-media-pause" : "cis-media-play"}
          theme="secondary"
          shape="round"
        >
          {props.buttonLabel}
        </Button>
      </div>
      {autoplay && (
        <block.audio
          src={fileUrl}
          autoplay={autoplay}
          key={`audioSlider_${sliderIndex}`}
          styles={{ display: "none" }}
        />
      )}
    </div>
  );
};
